import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

export default function BusVehicleList({
  vehicles,
  stakeholder,
  onView,
  onSell,
  onFavorite
}) {
  return (
    <>
      <h3 className="text-sm font-semibold mb-2">Nearby Buses</h3>

      <div className="space-y-2 overflow-auto h-full">
        {vehicles.map(v => (
          <div
            key={v.id}
            className="bg-gray-800 p-2 rounded flex items-start justify-between gap-2"
          >
            {/* LEFT: Route + Status */}
            <div className="flex flex-col text-left">
              <div className="text-sm font-medium">
                {v.id} • {v.route}
              </div>
              <div className="text-xs text-gray-400">
                Status: <b>{v.status}</b>
              </div>
            </div>

            {/* RIGHT: Actions */}
            <div className="flex flex-col items-end gap-1">
              <button
                className="w-20 px-2 py-1 bg-indigo-600 rounded text-xs"
                onClick={() => onView(v)}
              >
                View
              </button>

              {stakeholder === "Passenger" && (
                <button
                  className="w-20 px-2 py-1 bg-pink-600 rounded text-xs flex items-center justify-center"
                  onClick={() => onFavorite(v.route)}
                >
                  <FontAwesomeIcon icon={faHeart} />
                </button>
              )}

              {stakeholder === "Attendant" && (
                <button
                  className="w-20 px-2 py-1 bg-green-600 rounded text-xs"
                  onClick={() => onSell(v.id)}
                >
                  Sell
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

